import { TypedUseSelectorHook, useSelector } from "react-redux";
import { getAssisteur } from "../redux/ProgrammeRedux";
import { RootState } from "../redux/reducers";

export const useReduxSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAssisteur = () => {
  const infoAssisteur = useReduxSelector((state) => getAssisteur(state));
  return {
    infoAssisteur,
  };
};
